export enum OrderActionType {
  CREATE_ORDER_SUCCESS = "create_order_sucess",
  CREATE_ORDER_FALIURE = "create_order_failure",
  CREATE_ORDER = "create_order",
  FETCH_ORDER_DETAILS = "fetch_order_details",
  FETCH_ORDER_DETAILS_SUCCESS = "fetch_order_details_success",
  FETCH_ORDER_DETAILS_FAILURE = "fetch_order_details_failure",
  PAY_ORDER = "pay_order",
  PAY_ORDER_SUCCESS = "pay_order_success",
  PAY_ORDER_FAILURE = "pay_order_failure",
  PAY_ORDER_RESET = "pay_order_reset",
}
